<script setup>
defineProps({
  status: {
    type: String,
    default: 'idle',
    validator: (v) => ['idle', 'saving', 'saved'].includes(v),
  },
  color: {
    type: String,
    default: '#009ad0',
  },
})
</script>

<template>
  <div class="fixed top-4 inset-x-0 flex justify-center z-50 pointer-events-none">
    <Transition name="autosave-pill">
      <div v-if="status !== 'idle'" class="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs text-white shadow-md" :style="{ backgroundColor: color }">
        <template v-if="status === 'saving'">
          <svg class="animate-spin h-3 w-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
          <span>Saving...</span>
        </template>
        <template v-else-if="status === 'saved'">
          <svg class="h-3 w-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
          </svg>
          <span>Saved</span>
        </template>
      </div>
    </Transition>
  </div>
</template>

<style scoped>
.autosave-pill-enter-active {
  transition: all 0.2s ease;
}
.autosave-pill-leave-active {
  transition: all 0.4s ease;
}
.autosave-pill-enter-from,
.autosave-pill-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
